import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/circle-check.tsx
function CircleCheck({ role = "img", strokeWidth = 1, ...svg }) {
	return /* @__PURE__ */ jsxs("svg", {
		role,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "none",
		stroke: "currentColor",
		strokeWidth,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		...svg,
		children: [/* @__PURE__ */ jsx("circle", {
			cx: "12",
			cy: "12",
			r: "10"
		}), /* @__PURE__ */ jsx("path", { d: "m16 9-5.5 5.5L8 12" })]
	});
}
//#endregion
export { CircleCheck };
